<template>
  <div>
    <template v-if="isLoading">
      <md-table>
        <md-table-row>
          <md-table-cell colspan="4">
            <div class="spinner"></div> 
          </md-table-cell>
        </md-table-row>
      </md-table>
    </template>
    <template v-else>
      <div style="max-width:470px;min-width:auto;overflow:hidden;word-wrap:break-word">
        <!-- <md-table-toolbar style="max-width:730px;min-width:auto;">
          <h4>Task Name: </h4>
          <md-table-row><md-table-cell colspan="4"><h5 style="margin:0px">{{activeTask.name}}</h5></md-table-cell></md-table-row>
        </md-table-toolbar> -->
            <!-- <br> -->
          <div style="padding-left:20px;">
              <h5>Assign Task</h5>
            
              <div class="assignDetailsStyle" >
                 <div>
                    <p style="margin:0px;font-weight:900">Assignee</p>
                </div>
                <div v-if="activeTask.assignee" class="assignelementstyle" >
                  <p style="margin:0px;width:150px;">{{ assigneeEmail }}</p>
                </div> 
                <div>
                  <div v-if="activeTask.assignee">
                    <md-button v-if="!visible" class="md-primary md-raised" @click="openAssignPopUp">Re-assign</md-button>
                    <md-button v-if="cancleVisible" class="md-raised" style="background-color:grey;color:white;" @click="openAssignPopUp">Cancel</md-button>
                  </div>
                  <div v-else>
                    <md-button  v-if="!visible" class="md-primary md-raised" @click="openAssignPopUp">Assign</md-button>
                    <md-button  v-if="cancleVisible" class="md-raised" style="background-color:grey;color:white;" @click="openAssignPopUp">Cancel</md-button>  
                  </div>
                </div>
              </div> 
              <!-- <md-autocomplete v-if="visible" v-model="selectedEmployee" :md-options="employees" md-dense style="margin-left:20px;">
                <label>Enter Email </label>
              </md-autocomplete> -->
              <form @submit.prevent="assignValue">
                <md-autocomplete v-if="visible" v-model="selectedEmployee" :md-options="[]" md-dense style="margin-left:20px;width:400px">
                  <label>Email</label>
                  <span class="md-helper-text" v-if="!assignValueNull">Press enter key to search</span>
                  <span class="md-helper-text" style="color:rgb(236, 91, 91)" v-else>Press enter and select the value form the dropdown before submitting.</span>

                </md-autocomplete>
              </form>
              <div v-if="visible && optionsVisible" class="menuDiv">
                <md-list >
                  <md-list-item  v-for="option in searched" :key="option.id" @click="selectthisvalue(option)">{{ option.email }} </md-list-item>
                </md-list>
              </div>
              <div class="buttonToRight">
                <md-button  v-if="visible" class="md-primary md-raised" style="margin-left:20px;margin-top:10px;float:left" @click="submitToAssign">submit</md-button>
              </div>
            
          </div> 
      </div>
    </template>
    <!-- <BModal :id="ActiveTaskAssignID" :ref="ActiveTaskAssignID" title=" Assign Owner" size="lg">
      <FRViewRelationshipAssignOwner></FRViewRelationshipAssignOwner>
      <div slot="modal-footer" class="w-100"></div>
    </BModal> -->
  </div>
</template>

<script>
import { generateIdmApi } from '../../../api/BaseApi';
import FrIcon from '@forgerock/platform-shared/src/components/Icon';
import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
export default {
  name: 'RelationshipViewActiveTask',
  components: {
    FrIcon,
  },
  props: {
    itemSelected: {
      type: Object,
      required: true,
    },
    

  },
  data() {
    return {
      realmIsEA : (localStorage.getItem('originalLoginRealm') == '/EA' || localStorage.getItem('originalLoginRealm') == 'EA' || localStorage.getItem('originalLoginRealm') == 'EA/') ? true : false,
      selectedEmployee: null,
      visible:false,
      cancleVisible:false,
      activeTask: [],
      searched: [],
      isLoading: false,
      optionID:'',
      selectedActive: null,
      assigneeEmail:"",
      ActiveTaskAssignID: `AssignOwner`,
      optionsVisible:false,
      assignValueNull:false,
      errorMessage:"",

    }
  },
  mounted() {
    console.log("==================> : ", this.itemSelected)
    this.getTaskInstance();
  },
  methods: {
    openAssignPopUp(){
      this.visible=!this.visible;
      this.cancleVisible=!this.cancleVisible;
    },
    assignValue(event){
      event.preventDefault();
      var optionValues=[];
      if(this.selectedEmployee !== ""){
        if(this.realmIsEA){
          generateIdmApi().get('/managed/ea_user?_queryFilter=mail%20sw%20%22'+ this.selectedEmployee+'%22')
          .then((response) => {
            console.log("values ======>", response.data.result)
            var assigneeEmail = response.data.result
            for (var value in assigneeEmail){
              var objectToPush={};
              objectToPush.email =assigneeEmail[value].mail
              objectToPush.id=assigneeEmail[value]._id
              optionValues.push(objectToPush)
            }
            this.searched = optionValues
            this.optionsVisible=true
            console.log(optionValues)
            }).catch((error) => {
                console.error('error', error);
            });
          } else {  
            generateIdmApi().get('/managed/user?_queryFilter=mail%20sw%20%22'+ this.selectedEmployee+'%22')
            .then((response) => {
              console.log("values ======>", response.data.result)
              var assigneeEmail = response.data.result
              for (var value in assigneeEmail){
                var objectToPush={};
                objectToPush.email =assigneeEmail[value].mail
                objectToPush.id=assigneeEmail[value]._id
                optionValues.push(objectToPush)
              }
              this.searched = optionValues
              this.optionsVisible=true
              console.log(optionValues)
              }).catch((error) => {
                  console.error('error', error);
              });
        }
      } else {
        this.optionsVisible=false;
      }
    },
    selectthisvalue(option){
      this.assignValueNull = false;
      this.selectedEmployee = option.email ;
      this.optionID = option.id;
      this.optionsVisible=false;
    },
    handleClear(){
      console.log("I am")
      this.optionsVisible=false;
    },
    async submitToAssign(){
      console.log("submitToAssign called")
      if(this.optionID !=="" && !!this.optionID) {
        this.assignValueNull = false;
        const payload = {
          "assignee": this.optionID,
          "description": null,
          "name": this.itemSelected.name,
          "owner": null,
          "category": null,
          "dueDate": null,
          "priority": 50
        }
        const url = `${process.env.VUE_APP_IDM_URL}/workflow/taskinstance/` + this.itemSelected._id;
        const headers = {
          'Content-Type': 'application/json',
          'If-Match':'3'
        };
        console.log(payload);
        try {
          const response = await axios.put(url, payload, { headers });
          console.log(response.data);
          this.visible=false;
          this.cancleVisible=false
          this.isLoading = true;
          await this.getTaskInstance();
          this.isLoading = false;
          this.$emit('data-to-parent', true);
        } catch (error) {
          console.error(error);
        }
      } else {
        this.assignValueNull = true;
        this.errorMessage =""
      }
    },
    async getTaskInstance() {
      var tableData = []
      this.isLoading = true;
        try {
          tableData = await axios.get(`${process.env.VUE_APP_IDM_URL}/endpoint/activeTaskIndividual?taskId=` + this.itemSelected._id);
        } catch (error) {
          console.error(error);
        }
        if(!!tableData.data.data){
          this.activeTask = tableData.data.data
          console.log("====> activeTask " , this.activeTask)
          if(this.activeTask.assignee){
            this.getMailAssigneeId();
          }
        } else {
          this.activeTask = [];
        }
        this.isLoading = false;
    },
    getMailAssigneeId(){
      if(this.realmIsEA){
        generateIdmApi().get('/managed/ea_user/' + this.activeTask.assignee)
        .then((response) => {
          console.log("values ======>", response.data.mail)
          this.assigneeEmail = response.data.mail
          }).catch((error) => {
              console.error('error', error.response.data.message);
          });
      } else {
        generateIdmApi().get('/managed/user/' + this.activeTask.assignee)
        .then((response) => {
          console.log("values ======>", response.data.mail)
          this.assigneeEmail = response.data.mail
          }).catch((error) => {
              console.error('error', error.response.data.message);
          });
      }
    },
  }
}

</script>

<style>

.autocomplete {
    position: relative;
  }

.buttonToRight{
  display:flex;
  flex-direction:row;
  justify-content: flex-end;
}

.menuDiv{
  margin-left:20px;
  margin-top:0px;
  max-height:300px;
  overflow:auto;
  border:1px solid grey;
}

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    min-height: 1em;
    max-height: 6em;    
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
  }


.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #1a73e8;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s infinite linear;
  margin: 0 auto;
}
@keyframes spin {
  0% { transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
}

.selected-row {
  background-color: lightblue;
}

.valueColor {
  color: #00A9E0
}

.assignelementstyle{
  display:flex;
  flex-direction:column;
  align-items:center;
  padding-top:10px;
  width:350px;
}

.assignIDstyle{
  font-size:11px;
  background-color:#bfc5c7;
  padding:3px;
  border-radius: 30px;
}


.assignDetailsStyle{
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:space-between;
  padding-left:20px;
}

.md-menu-content
{   
    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
    min-width: 112px;
    max-width: 280px;
    max-height: 35vh;
    display: flex;
    flex-direction: row;
    position: absolute;
    z-index: 10000 !important;
    border-radius: 2px;
    transition: transform .2s cubic-bezier(.25,.8,.25,1),opacity .3s cubic-bezier(.25,.8,.25,1);
    will-change: opacity,transform,top,left!important;
}
</style>